import getAPIPath from '../modules/api-location';

window.loginUserService = function(data, successFn, errorFn) {
  $.ajax({
    url: `${getAPIPath}commandapi/auth/login`,
    type: 'POST',
    data,
    async: true,
    dataType: 'json',
    success: successFn,
    error: errorFn,
    xhrFields: {
      withCredentials: true,
    },

  });
};

window.resetPasswordService = function(data, successFn, errorFn) {
  $.ajax({
    url: `${getAPIPath}commandapi/auth/reset-password`,
    type: 'POST',
    data,
    async: true,
    dataType: 'json',
    success: successFn,
    error: errorFn,
    xhrFields: {
      withCredentials: true,
    },

  });
};

window.createNewPasswordService = function(data, successFn, errorFn) {
  $.ajax({
    url: `${getAPIPath}commandapi/auth/create-password`,
    type: 'POST',
    data,
    async: true,
    dataType: 'json',
    success: successFn,
    error: errorFn,
    xhrFields: {
      withCredentials: true,
    },

  });
};



// WEBPACK FOOTER //
// ./library/js/services/authentication.service.js